export const setHeaderStyle = (color, isFullScreenWidget) => ({
  backgroundColor: color,
  borderRadius: isFullScreenWidget ? '0' : '10px 10px 0 0',
})
